import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./passwordField.css";

const PasswordField = ({
    value,
    onChange,
    placeholder,
    autoComplete = "new-password",
    className = "",
    onKeyDown,
    id,
}) => {
    const [show, setShow] = useState(false);

    return (
        <div className="password-wrapper">
            <input
                id={id}
                className={`input ${className}`}
                type={show ? "text" : "password"}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                autoComplete={autoComplete}
            />

            <button
                type="button"
                className="password-toggle"
                onClick={() => setShow(!show)}
                aria-label={show ? "Hide password" : "Show password"}
                tabIndex={-1}
            >
                {show ? (
                    <EyeOff size={18} strokeWidth={2} />
                ) : (
                    <Eye size={18} strokeWidth={2} />
                )}
            </button>
        </div>
    );
};

export default PasswordField;
